import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { MdDashboard, MdSettings, MdTune } from 'react-icons/md';
import { BiMicrophone } from 'react-icons/bi';
import { RiAiGenerate, RiPresentationLine } from 'react-icons/ri';
import { FiLogOut } from 'react-icons/fi';
import { HiMenu, HiX } from 'react-icons/hi';
import api from '../utils/axios';
import './Navbar.css';
import NotificationBadge from './NotificationBadge';

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const token = localStorage.getItem('token');
    const decodedToken = token ? jwtDecode(token) : null;
    const isAdmin = decodedToken?.role === 'admin';

    const [pendingRequests, setPendingRequests] = useState(0);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const fetchPendingRequests = async () => {
            try {
                const response = await api.get('/user/connections/pending');
                setPendingRequests(response.data.length);
            } catch (error) {
                console.error('Error fetching pending requests:', error);
            }
        };

        const interval = setInterval(fetchPendingRequests, 30000); // Check every 30 seconds
        fetchPendingRequests();

        return () => clearInterval(interval);
    }, []);

    const handleLogout = async () => {
        try {
            const token = localStorage.getItem('token');
            await api.post('/auth/logout', null, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            localStorage.removeItem('token');
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    return (
        <nav className="navbar">
            <img src="/logo.svg" alt="SwavAI" className="navbar-logo" />
            <button
                className="hamburger-button"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
                {isMenuOpen ? <HiX /> : <HiMenu />}
            </button>
            <div className={`navbar-links ${isMenuOpen ? 'show' : ''}`}>
                {isAdmin ? (
                    <Link to="/admin" className={location.pathname === '/admin' ? 'active' : ''}>
                        <MdDashboard /> <span>Admin Dashboard</span>
                    </Link>
                ) : (
                    <>
                        <Link
                            to="/presgen"
                            className={location.pathname === '/presgen' ? 'active' : ''}
                        >
                            <RiPresentationLine /> <span>PresGen</span>
                        </Link>
                        <Link to="/practice" className={location.pathname === '/practice' ? 'active' : ''}>
                            <RiAiGenerate /> <span>Practice</span>
                        </Link>
                        <Link
                            to="/sessions"
                            className={location.pathname === '/sessions' ? 'active' : ''}
                        >
                            <BiMicrophone /> <span>Sessions</span>
                        </Link>
                        <Link to="/settings" className={`${location.pathname === '/settings' ? 'active' : ''} settings-tab-badge`}>
                            <MdSettings /> <span>Settings</span>
                            <NotificationBadge count={pendingRequests} />
                        </Link>
                    </>
                )}
                <button onClick={handleLogout} className="logout-button">
                    <FiLogOut /> <span>Logout</span>
                </button>
            </div>
            {isMenuOpen && <div className="menu-overlay" onClick={() => setIsMenuOpen(false)} />}
        </nav>
    );
};

export default Navbar;